import Formatter from 'shared/utils/formatters'
import ConsultZipCodeRequest from '../entities/ConsultZipCodeRequest'
import ConsultZipCodeResponse from '../entities/ConsultZipCodeResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IConsultZipCode {
  execute(params: ConsultZipCodeRequest): Promise<ConsultZipCodeResponse>
}

export default class ConsultZipCodeImpl implements IConsultZipCode {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(
    params: ConsultZipCodeRequest,
  ): Promise<ConsultZipCodeResponse> {
    const response = await this.userRepository.consultZipCode({
      cep: params.cep.replace(Formatter.somenteNumeros(), ''),
    })

    return response
  }
}
